import script from "./assistant-conversation.vue?vue&type=script&setup=true&lang=ts"
export * from "./assistant-conversation.vue?vue&type=script&setup=true&lang=ts"

import "./assistant-conversation.vue?vue&type=style&index=0&id=10681817&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10681817"]])

export default __exports__